//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpActionStatus implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idActionStatus: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdActionStatus
    }
    public getReferenceKey(): number {
        return this.idActionStatus
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idActionStatus = opObj.ID_ACTION_STATUS
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ACTION_STATUS: this.idActionStatus,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            _Descr: this.descr ? this.descr.toJSON() : null,
            OpState: this.opState
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpActionStatus[]): JQueryPromise<OpActionStatus[]> {
        var defered = $.Deferred<OpActionStatus[]>()

        defered.resolve(list)

        return defered.promise()
    }
}